import * as React from 'react';
import { RegisteredLoadingIndicator, RegisteredErrorInfo } from 'piral-core';
import { useFeed } from './useFeed';
export function withFeed(Component, options) {
    const FeedView = (props) => {
        const [loaded, data, error] = useFeed(options);
        if (!loaded) {
            return React.createElement(RegisteredLoadingIndicator, null);
        }
        else if (data) {
            return React.createElement(Component, { ...props, data: data });
        }
        else {
            return React.createElement(RegisteredErrorInfo, { type: "feed", error: error });
        }
    };
    FeedView.displayName = `FeedView_${options.id}`;
    return FeedView;
}
//# sourceMappingURL=withFeed.js.map